import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import LicenseExpiryBanner from './LicenseExpiryBanner';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { useLicenseBanner } from '../context/LicenseBannerContext';

const Layout = ({ children, noCard = false }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false); // false by default for mobile
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { isRTL } = useTranslation();
  const { bannerHeight } = useLicenseBanner();

  // Always open sidebar on desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Disable body scroll when sidebar is open on mobile
  useEffect(() => {
    const isMobile = window.innerWidth < 1024;
    if (sidebarOpen && isMobile) {
      // Save current scroll position
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      
      return () => {
        // Restore scroll position when sidebar closes
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, [sidebarOpen]);

  // useEffect(() => {
  //   console.log('Layout useEffect: user=', user, 'loading=', loading);
  //   // Removed redirect logic since logout function handles it directly
  //   // No additional redirect logic needed here
  // }, [user, loading]);

  return (
    <div className={`min-h-screen flex flex-col bg-[#F6F9FF] relative overflow-x-hidden ${isRTL ? 'flex-row-reverse' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <LicenseExpiryBanner />
      <div className="flex flex-1 min-h-0">
        <Sidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
        />
        {/* Mobile overlay only */}
        <div
          className={`lg:hidden fixed inset-0 z-30 bg-black bg-opacity-20 transition-opacity duration-300 ${sidebarOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
          onClick={() => setSidebarOpen(false)}
        />
        
        <div className={`flex-1 flex flex-col transition-all duration-300 min-h-screen overflow-x-hidden ${sidebarOpen || window.innerWidth >= 1024 ? (sidebarCollapsed ? (isRTL ? 'lg:pr-20' : 'lg:pl-20') : (isRTL ? 'lg:pr-64' : 'lg:pl-64')) : ''}`}>
          <Header
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarCollapsed={sidebarCollapsed}
            setSidebarCollapsed={setSidebarCollapsed}
          />
     
        <main
          className="flex-1 md:p-6 lg:p-8 w-full max-w-7xl mx-auto overflow-x-hidden bg-white md:bg-transparent"
          style={{ paddingTop: bannerHeight > 0 ? `${bannerHeight}px` : undefined }}
        >
          {noCard ? (
            <div className="px-[16px] py-[20px] md:p-0">
              {children}
            </div>
          ) : (
            <div className="bg-white md:rounded-2xl md:shadow-md px-[16px] py-[20px] md:p-6 lg:p-8 min-h-screen md:min-h-[80vh] overflow-x-hidden">
              {children}
            </div>
          )}
        </main>
        </div>
      </div>
    </div>
  );
};

export default Layout; 